import React from 'react'
import './ProductDescription.css'

const ProductDescription = ({ product }) => {

    if (!product) return null

    const hasSizes = product.sizes  && product.sizes.length  > 0
    const hasColors = product.colors && product.colors.length > 0
    const hasTags = product.tags   && product.tags.length   > 0
    const hasMaterial = product.material && product.material.trim() !== ''

    return (
        <div className="pd-section">

            {/* Tab bar title */}
            <div className="pd-tab-bar">
                <div className="pd-tab pd-tab--active">Description</div>
            </div>

            {/* Content box */}
            <div className="pd-content">

                {/* Group 1 Product Details */}
                <div className="pd-group">
                    <p className="pd-group-label">Product Details</p>
                    <div className="pd-details-grid">
                        <span className="pd-detail-key">Name</span>
                        <span className="pd-detail-val">{product.name}</span>

                        <span className="pd-detail-key">Category</span>
                        <span className="pd-detail-val" style={{ textTransform: 'capitalize' }}>{product.category}, {product.subCategory}</span>

                        {hasMaterial && (
                            <>
                                <span className="pd-detail-key">Material</span>
                                <span className="pd-detail-val">{product.material}</span>
                            </>
                        )}

                        <span className="pd-detail-key">Store ID</span>
                        <span className="pd-detail-val pd-mono">{product.storeProductId}</span>

                        <span className="pd-detail-key">Availability</span>
                        <span className={`pd-detail-val ${product.available ? 'pd-available' : 'pd-unavailable'}`}>
                            {product.available ? 'In Stock' : 'Out of Stock'}
                        </span>
                    </div>
                </div>

                {/* Group 2: Sizes & Colors */}
                {(hasSizes || hasColors) && (
                    <div className="pd-group">
                        <p className="pd-group-label">Sizes & Colors</p>

                        {hasSizes && (
                            <div className="pd-attr-row">
                                <span className="pd-attr-key">Sizes</span>
                                <div className="pd-chips">
                                    {product.sizes.map(size => (
                                        <span key={size} className="pd-chip">{size}</span>
                                    ))}
                                </div>
                            </div>
                        )}

                        {hasColors && (
                            <div className="pd-attr-row">
                                <span className="pd-attr-key">Colors</span>
                                <div className="pd-chips">
                                    {product.colors.map(color => (
                                        <span key={color.hex + color.name} className="pd-chip">
                                            {color.name}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {/* Group 3: Tags */}
                {hasTags && (
                    <div className="pd-group pd-group--last">
                        <p className="pd-group-label">Collections & Tags</p>
                        <div className="pd-chips">
                            {product.tags.map(tag => (
                                <span key={tag} className="pd-chip pd-chip--tag">{tag}</span>
                            ))}
                        </div>
                    </div>
                )}

            </div>
        </div>
    )
}

export default ProductDescription